import React from "react";

const Button = ({ variant = "", children, className = "", ...props }) => {
  return (
    <button
      className={`${variant} ${className}`}
      {...props}
    >
      {children}
    </button>
  );
};

export default Button;

